import React from "react";

import { UIConfigContext } from "./UIConfigContext";
import { MenuOverlayView } from "./Party";

const fbLogoURL = "https://popcorn-images-prod.s3.us-west-2.amazonaws.com/party/FB-logo-200.png"

export type TitleBarProps = {
    count : number;
    onDesktop : boolean;
    clickOn : (index : number) => void;
    menuItems : MenuOverlayView[];
    selectSetter : (f : (index : number) => void) => void;
  }
  
  export const TitleBar = ({ count, onDesktop, clickOn, menuItems, selectSetter} : TitleBarProps) : React.JSX.Element=> {
    const [selected, setSelected] = React.useState<number>(0);

    const select = (index : number) => {
      setSelected(index);
    }

    selectSetter(select);



    const uiConfig = React.useContext(UIConfigContext);
    return (
      <div style={{
        minWidth: uiConfig.width,
        minHeight: uiConfig.titleHeight,
        maxHeight: uiConfig.titleHeight,
        gridColumn: onDesktop ? "1 / span 2" : "1",
        gridRow: 1,
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "auto",
        borderBottom : "2px solid white" ,
        backgroundColor : uiConfig.fanboxColor('darkPink')
  
      }}
      >
        <div style={{ gridRow: 1, gridColumn: 1, justifyContent: "left", display : 'flex', flexDirection : 'row'}}>
          {menuItems.map((item, index)=> {
            const onClick = () => { setSelected(index); clickOn(index);}
            const key = 'TitleBar_MenuOverlayButton_'+index;
            //console.log(key);
            const ret = item.icon(uiConfig.fontBase * 2, onClick, key, index === selected, uiConfig);
            //console.log(ret.key);
            return ret;
          })}
        </div>
        <span style={{ fontSize: uiConfig.fontBase * 1.5, textAlign: "right", color: "white", gridRow: 1, gridColumn: 2 }} >{"Undiscovered (" + count + ")"}</span>
      </div>
      
    )
  }